import "./json_item_lst.css";
import { useItems } from "../../contexts/item_context";
import { useState } from "react";

const FileIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
    </svg>
);

const CloseIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export default function ScrollableLst() {
    const { items, removeItem, updateItemName, selectItem, activeItem } = useItems();
    const [editingId, setEditingId] = useState(null);

    const stopEditing = () => setEditingId(null);

    return (
        <div className="file-list">
            {items.map((item) => {
                const isActive = activeItem?.id === item.id;
                const isEditing = editingId === item.id;

                return (
                    <div
                        key={item.id}
                        className={`file-item${isActive ? " file-item--active" : ""}`}
                        onClick={() => selectItem(item.id)}
                        title={item.name}
                    >
                        <span className={`file-item__icon${isActive ? " file-item__icon--active" : ""}`}>
                            <FileIcon />
                        </span>

                        <input
                            className="file-item__name"
                            value={item.name}
                            readOnly={!isEditing}
                            onDoubleClick={(e) => {
                                e.stopPropagation();
                                setEditingId(item.id);
                                e.target.select();
                            }}
                            onChange={(e) => updateItemName(item.id, e.target.value)}
                            onClick={(e) => {
                                e.stopPropagation();
                                selectItem(item.id);
                            }}
                            onBlur={stopEditing}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") { e.preventDefault(); stopEditing(); }
                                if (e.key === "Escape") { stopEditing(); }
                            }}
                            spellCheck={false}
                        />

                        <button
                            className="file-item__close"
                            onClick={(e) => {
                                e.stopPropagation();
                                removeItem(item.id);
                            }}
                            title="Delete file"
                            type="button"
                        >
                            <CloseIcon />
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
